/** @format */

import { useEffect } from 'react';

import { useDispatch, useSelector } from 'src/store';
import { getFooterLinksInfo } from 'src/slices/global';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const dispatch = useDispatch();
  const { footerLinks } = useSelector(state => state.global);

  useEffect(() => {
    if (!footerLinks) {
      dispatch(getFooterLinksInfo());
    }
    // eslint-disable-next-line
  }, []);

  const getRedirectURL = item => {
    if (item?.nid) {
      // if (item.public) {
      //   return `/page/public/${item?.nid}`;
      // }
      return `/page/${item?.nid}`;
    }
    return '/404';
  };

  const currentYear = new Date().getFullYear();

  // const BuildVersion = () => {
  //   return <p align="end" className="buildVersion">{getBuildVersion()}</p>;
  // };

  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-inner">
            <span className="footer-copyright">
              © AUMOVIO Aftermarket GmbH <span>{currentYear || '2023'}</span>
            </span>
            <ul className="footer-link">
              {footerLinks &&
                footerLinks.map((item, index) => {
                  return (
                    <li key={index}>
                      <Link to={getRedirectURL(item)}>{item.title}</Link>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};
